import { Box } from '@mui/material';

export function Loader({
  size = 'large',
  className = '',
  color,
}: {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  color?: string;
}) {
  return (
    <Box
      className={`flex justify-center h-full items-center ${className}`}
      sx={color ? { color } : undefined}
    >
      {size === 'large' && (
        <i className='line-md-loading-loop w-[50px] h-[50px]' />
      )}
      {size === 'medium' && (
        <i className='line-md-loading-loop w-[24px] h-[24px]' />
      )}
      {size === 'small' && (
        <i className='line-md-loading-loop w-[12px] h-[12px]' />
      )}
    </Box>
  );
}
